<template>
  <div>
    <!-- 使用公共导航栏组件 -->
    <Nav />

    <!-- 注册表单容器 -->
    <div class="flex-1 flex items-center justify-center px-4 py-12 pt-20">
      <div class="w-full max-w-md">
        <div class="mb-8">
          <div class="text-center">
            <h1 class="text-2xl font-bold text-gray-900 mb-2">用户注册</h1>
            <p class="text-gray-600 text-sm">创建您的账户，开启便捷租赁体验</p>
          </div>
        </div>

        <div class="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
          <div class="space-y-6">
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2"
                >手机号</label
              >
              <div class="relative">
                <div
                  class="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 flex items-center justify-center"
                >
                  <i class="ri-phone-line text-gray-400"></i>
                </div>
                <input
                  type="tel"
                  v-model="mobile"
                  id="mobile"
                  class="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-transparent transition-colors"
                  placeholder="请输入手机号"
                  required
                />
              </div>
            </div>

            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2"
                >验证码</label
              >
              <div class="flex space-x-3">
                <input
                  type="text"
                  v-model="code"
                  class="flex-1 pl-3 pr-4 py-3 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-transparent transition-colors"
                  placeholder="请输入验证码"
                  maxlength="4"
                  required
                />
                <button
                  type="button"
                  @click="sendCode"
                  :disabled="countdown > 0"
                  class="whitespace-nowrap px-4 py-3 bg-primary text-white rounded-lg text-sm font-medium hover:bg-secondary transition-colors"
                >
                  {{
                    countdown > 0 ? `${countdown}秒后重新发送` : "发送验证码"
                  }}
                </button>
              </div>
            </div>

            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2"
                >密码</label
              >
              <div class="relative">
                <div
                  class="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 flex items-center justify-center"
                >
                  <i class="ri-lock-line text-gray-400"></i>
                </div>
                <input
                  :type="showPassword ? 'text' : 'password'"
                  v-model="password"
                  class="w-full pl-10 pr-12 py-3 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-transparent transition-colors"
                  placeholder="请输入密码"
                  required
                />
                <button
                  type="button"
                  @click="togglePasswordVisibility"
                  class="absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  <i
                    :class="showPassword ? 'ri-eye-line' : 'ri-eye-off-line'"
                  ></i>
                </button>
              </div>
              <div class="mt-2 text-xs text-gray-500">
                密码长度至少 8 位，包含字母和数字
              </div>
            </div>

            <div class="flex items-start">
              <label class="flex items-start cursor-pointer">
                <div class="relative">
                  <input
                    type="checkbox"
                    v-model="agreeTerms"
                    class="sr-only"
                    required
                  />
                  <div
                    :class="[
                      'w-5 h-5 border-2 rounded flex items-center justify-center transition-colors',
                      agreeTerms
                        ? 'border-primary bg-primary'
                        : 'border-gray-300 bg-white',
                    ]"
                  >
                    <i
                      v-if="agreeTerms"
                      class="ri-check-line text-white text-sm"
                    ></i>
                  </div>
                </div>
                <span class="ml-3 text-sm text-gray-600 leading-5">
                  我已阅读并同意
                  <router-link
                    to="/help/1"
                    class="text-primary hover:text-secondary transition-colors"
                    >《用户协议》</router-link
                  >
                  和
                  <router-link
                    to="/help/2"
                    class="text-primary hover:text-secondary transition-colors"
                    >《隐私政策》</router-link
                  >
                </span>
              </label>
            </div>

            <button
              type="submit"
              :disabled="loading"
              @click="handleRegister"
              class="w-full bg-primary text-white py-3 !rounded-button hover:bg-secondary transition-colors text-base font-medium whitespace-nowrap"
            >
              {{ loading ? "注册中..." : "注册账户" }}
            </button>

            <div class="text-center">
              <span class="text-sm text-gray-600">已有账户？</span>
              <router-link
                to="/login"
                class="text-sm text-primary hover:text-secondary transition-colors ml-1"
                >立即登录</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 使用公共页脚组件 -->
    <Footer />
  </div>
</template>

<script>
import Nav from "@/components/Nav.vue";
import Footer from "@/components/Footer.vue";
import api from "@/utils/api.js";

export default {
  name: "Register",
  components: {
    Nav,
    Footer,
  },
  data() {
    return {
      mobile: "",
      password: "",
      agreeTerms: false,
      loading: false,
      showPassword: false,
      // 验证码相关
      code: "",
      countdown: 0,
    };
  },
  methods: {
    async handleRegister() {
      // 表单验证
      if (!this.validateForm()) {
        return;
      }

      try {
        this.loading = true;
        // 调用API进行注册
        const response = await api.user.register({
          mobile: this.mobile,
          password: this.password,
          code: this.code,
        });

        // 注册成功后跳转到登录页面
        const redirect = this.$route.query.redirect || "/ucenter/index";
        if (response.code === 200) {
          setTimeout(() => {
            this.$router.push(redirect);
          }, 1500);
        }
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },

    validateForm() {
      // 验证手机号
      if (!this.mobile.trim()) {
        this.$message.warning("请输入手机号");
        return false;
      }

      // 验证手机号格式
      const mobileRegex = /^1[3-9]\d{9}$/;
      if (!mobileRegex.test(this.mobile)) {
        this.$message.warning("请输入有效的手机号");
        return false;
      }

      // 验证验证码
      if (!this.code.trim()) {
        this.$message.warning("请输入验证码");
        return false;
      }

      if (this.code.length !== 4 || !/^\d+$/.test(this.code)) {
        this.$message.warning("验证码格式不正确");
        return false;
      }

      // 验证密码格式
      if (!this.password) {
        this.$message.warning("请输入密码");
        return false;
      }

      if (this.password.length < 8) {
        this.$message.warning("密码长度至少为8位");
        return false;
      }

      const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;
      if (!passwordRegex.test(this.password)) {
        this.$message.warning("密码必须包含字母和数字");
        return false;
      }

      // 验证是否同意用户协议
      if (!this.agreeTerms) {
        this.$message.warning("请阅读并同意用户协议和隐私政策");
        return false;
      }

      return true;
    },

    async sendCode() {
      if (!this.mobile.trim()) {
        this.$message.warning("请输入手机号");
        return;
      }

      // 验证手机号格式
      const mobileRegex = /^1[3-9]\d{9}$/;
      if (!mobileRegex.test(this.mobile)) {
        this.$message.warning("请输入有效的手机号");
        return;
      }

      // 发送验证码API调用
      try {
        // 这里应该调用发送验证码的API
        const response = await api.code.send({
          mobile: this.mobile,
          event: "register",
        });

        // 开始倒计时
        this.countdown = 60;
        const timer = setInterval(() => {
          this.countdown--;
          if (this.countdown <= 0) {
            clearInterval(timer);
          }
        }, 1000);
      } catch (error) {}
    },

    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
  },
};
</script>

<style scoped>
/* 自定义样式 */
</style>



// WEBPACK FOOTER //
// src/pages/Register.vue